import React, { PureComponent } from "react";

import { Bar } from "react-chartjs-2";

const data = {
  labels: ["Tägliche ", "Wöchentlich", "Monatlich", "Jährlich"],
  datasets: [
    {
      label: "Bestellungen",
      backgroundColor: "rgba(255,99,132,0.2)",
      borderColor: "rgba(255,99,132,1)",
      borderWidth: 1,
      hoverBackgroundColor: "rgba(255,99,132,0.4)",
      hoverBorderColor: "rgba(255,99,132,1)",
      data: [20, 100, 300, 5000],
    },
    {
      label: "Umsatz",
      backgroundColor: "rgba(36, 138, 138, 1)",
      borderColor: "rgba(0, 201, 138, 1)",
      borderWidth: 1,
      hoverBackgroundColor: "rgba(36, 138, 138, 5)",
      hoverBorderColor: "rgba(255,99,132,1)",
      data: [300, 4000, 2211, 10000],
    },
  ],
};
export default class Timeline extends PureComponent {
  render() {
    return <Bar data={data} width={700} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Timeline.js